import React from 'react'

import { applyStyle, getSmartSize } from '../helpers/styles'
import { firstNotUndefined } from '../helpers/null'

const SIZES = {
  xsmall: 0.6,
  small: 0.8,
  normal: 1,
  medium: 1.25,
  large: 2,
  xlarge: 3,
  xxlarge: 4
}

export const usePaddingStyle = props => {
  let { padding, noPadding, paddingLeft, paddingRight, paddingBottom, paddingTop, paddingV, paddingH } = props

  paddingLeft = !noPadding && firstNotUndefined(paddingLeft, paddingH, padding)
  paddingRight = !noPadding && firstNotUndefined(paddingRight, paddingH, padding)
  paddingTop = !noPadding && firstNotUndefined(paddingTop, paddingV, padding)
  paddingBottom = !noPadding && firstNotUndefined(paddingBottom, paddingV, padding)

  return React.useMemo(() => {
    return `
      ${applyStyle('padding-left', paddingLeft, getSmartSize(paddingLeft, SIZES))}
      ${applyStyle('padding-right', paddingRight, getSmartSize(paddingRight, SIZES))}
      ${applyStyle('padding-top', paddingTop, getSmartSize(paddingTop, SIZES))}
      ${applyStyle('padding-bottom', paddingBottom, getSmartSize(paddingBottom, SIZES))}
    `
  }, [paddingLeft, paddingRight, paddingBottom, paddingTop])
}
